import {
    adapts,
    GoogleCloudStorageLinkedServiceAdapter
} from 'app/model/adapters/linkedservices/google-cloud-storage-linkedservice.adapter';
import { AdapterRegistry, IModel, Metamodel, SapDatasphereForGoogleCloudStorageLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapDatasphereForGoogleCloudStorageLinkedService),
    asynchronous: true,
    adapts
})
export class SapDatasphereForGoogleCloudStorageLinkedServiceAdapter extends GoogleCloudStorageLinkedServiceAdapter {
    protected modelConstructor(): new () => SapDatasphereForGoogleCloudStorageLinkedService {
        return SapDatasphereForGoogleCloudStorageLinkedService;
    }

    protected model(): IModel {
        return SapDatasphereForGoogleCloudStorageLinkedService.MODEL;
    }
}
